import script from "./ScreenEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenEditor.vue?vue&type=script&setup=true&lang=js"

import "./ScreenEditor.vue?vue&type=style&index=0&id=081e441c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-081e441c"]])

export default __exports__